import { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import { resultTimes, validaLabelMenuDatas } from 'src/utils/functions';
import moment from 'moment';
import v2_actionRelatorioChamados from 'src/actions/v2/dashboard/relatorios/v2_actionRelatorioChamados';
import v2_actionRelatorioChamadosUsuarios from 'src/actions/v2/dashboard/relatorios/v2_actionRelatorioChamadosUsuarios';
import MenuDatas2 from 'src/components/MenuDatas2';
import Iconify from 'src/components/Iconify';
import { Badge } from 'src/@/components/ui/badge';
import { Card, CardContent } from 'src/@/components/ui/card';
import { RELATORIOS_DESIGN as d } from 'src/sections/@dashboard/relatorios/Relatorios.design';
import GenericTable from 'src/components/table/GenericTable';
import { GENERIC_TABLE_DESIGN } from 'src/components/table/GenericTable.design';

const STATS_CONFIG = [
  { key: 'totalAberto', label: 'Abertos', icon: 'eva:folder-open-outline', color: 'blue' },
  { key: 'totalPendente', label: 'Pendentes', icon: 'eva:clock-outline', color: 'amber' },
  { key: 'totalConcluido', label: 'Concluidos', icon: 'eva:checkmark-circle-2-outline', color: 'green' },
  { key: 'tma', label: 'Tempo Conclusao', icon: 'eva:activity-outline', color: 'violet', isTma: true },
  { key: 'atrasados', label: 'Apos Prazo', icon: 'eva:alert-triangle-outline', color: 'orange' },
  { key: 'totalCancelado', label: 'Cancelados', icon: 'eva:close-circle-outline', color: 'gray' },
  { key: 'totalRecusado', label: 'Recusados', icon: 'eva:slash-outline', color: 'red' },
];

const TABLE_HEAD = [
  { id: 'usuario', label: 'Usuario', className: 'flex-[2] min-w-[180px]' },
  { id: 'abertos', label: 'Abertos', className: 'flex-1 min-w-[90px] text-center' },
  { id: 'pendentes', label: 'Pendentes', className: 'flex-1 min-w-[90px] text-center' },
  { id: 'concluidos', label: 'Concluidos', className: 'flex-1 min-w-[100px] text-center' },
  { id: 'tempo', label: 'Tempo Conclusao', className: 'flex-1 min-w-[130px] text-center' },
  { id: 'atrasados', label: 'Apos Prazo', className: 'flex-1 min-w-[100px] text-center' },
  { id: 'recusados', label: 'Recusados', className: 'flex-1 min-w-[90px] text-center' },
  { id: 'cancelados', label: 'Cancelados', className: 'flex-1 min-w-[100px] text-center' },
];

export default function RelatorioChamados() {
  const { user } = useAuth();
  const [inicial, setInicial] = useState(new Date());
  const [final, setFinal] = useState(new Date());
  const [metricasChamados, setMetricasChamados] = useState(null);
  const [listaMetricasUsuarios, setListaMetricasUsuarios] = useState([]);
  const [periodo, setPeriodo] = useState('mes_atual');
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenuDatas = Boolean(anchorEl);

  useEffect(() => {
    handleBuscarDadosChamados(periodo);
  }, [inicial, final]);

  const handleBuscarDadosChamados = async (value) => {
    try {
      let inicio2 = moment(inicial).format('YYYY-MM-DD');
      let final2 = moment(final).format('YYYY-MM-DD');
      let querys = `?periodo=${value}&cliente_id=${user.clienteId}&inicio=${inicio2}&final=${final2}`;
      const res = await v2_actionRelatorioChamados(querys);
      const res2 = await v2_actionRelatorioChamadosUsuarios(querys);
      setMetricasChamados(res.data.data.total);
      setListaMetricasUsuarios(res2.data.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const getStatValue = (stat) => {
    if (!metricasChamados) return 0;
    if (stat.isTma) return 0;
    return metricasChamados[stat.key] || 0;
  };

  return (
    <div className={d.page.container}>
      {/* Header */}
      <div className={d.page.header.container}>
        <div className={d.page.header.left}>
          <div className={d.page.header.iconBox}>
            <Iconify icon="eva:file-text-outline" width={28} className={d.page.header.icon} />
          </div>
          <div>
            <h1 className={d.page.header.title}>Relatorio de Chamados</h1>
            <p className={d.page.header.subtitle}>Metricas e desempenho dos chamados por periodo</p>
          </div>
        </div>
        <div className={d.page.header.right}>
          <div className={d.filters.group}>
            <label className={d.filters.label}>Periodo</label>
            <MenuDatas2
              onClose={() => setAnchorEl(null)}
              anchorEl={anchorEl}
              open={openMenuDatas}
              inicial={inicial}
              final={final}
              changeInicial={(newValue) => setInicial(newValue)}
              changeFinal={(newValue) => setFinal(newValue)}
              content={validaLabelMenuDatas(periodo, inicial, final)}
              onSelect={(value) => {
                setPeriodo(value);
                setAnchorEl(null);
                handleBuscarDadosChamados(value);
              }}
              onPesquisar={() => handleBuscarDadosChamados('null')}
            />
          </div>
        </div>
      </div>

      {/* Two-column layout */}
      <div className={d.twoColumn.container}>
        {/* Sidebar - Stats */}
        {metricasChamados && (
          <div className={d.twoColumn.sidebar}>
            {STATS_CONFIG.map((stat) => (
              <Card key={stat.key} className={d.sidebarStat.card}>
                <CardContent className={d.sidebarStat.cardContent}>
                  <div className={d.sidebarStat.row}>
                    <div className={`${d.sidebarStat.iconBox.base} ${d.sidebarStat.iconBox[stat.color]}`}>
                      <Iconify icon={stat.icon} className={d.sidebarStat.icon[stat.color]} />
                    </div>
                    <div className="flex-1">
                      <p className={d.sidebarStat.label}>{stat.label}</p>
                      <p className={d.sidebarStat.value}>{getStatValue(stat)}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}

        {/* Content - Table */}
        <div className={d.twoColumn.content}>
          {listaMetricasUsuarios.length > 0 ? (
            <Card className={d.tableCard.container}>
              <CardContent className={d.tableCard.cardContent}>
                <div className={d.tableCard.filterBar}>
                  <h3 className={d.tableCard.filterTitle}>Metricas por Usuario</h3>
                </div>
                <div className="overflow-auto flex-1 min-h-0">
                  <GenericTable headLabels={TABLE_HEAD}>
                    {listaMetricasUsuarios.map((row) => {
                      let tma = row.tma / row.count_tma;
                      return (
                        <div key={row._id} className={GENERIC_TABLE_DESIGN.row.container}>
                          <div className="flex-[2] min-w-[180px] pr-4">
                            <div className="flex items-center gap-3">
                              <div className="w-8 h-8 rounded-lg bg-violet-50 flex items-center justify-center">
                                <Iconify icon="eva:person-outline" width={16} className="text-violet-600" />
                              </div>
                              <span className={d.table.cellBold}>{row.nomeUsuario}</span>
                            </div>
                          </div>
                          <div className="flex-1 min-w-[90px] text-center">
                            {row.totalAberto ? (
                              <Badge variant="outline" className={d.badges.status.aberto}>
                                <span className={d.badges.dot.blue} />
                                {row.totalAberto}
                              </Badge>
                            ) : (
                              <span className="text-sm text-gray-400">-</span>
                            )}
                          </div>
                          <div className="flex-1 min-w-[90px] text-center">
                            {row.totalPendente ? (
                              <Badge variant="outline" className={d.badges.status.pendente}>
                                <span className={d.badges.dot.amber} />
                                {row.totalPendente}
                              </Badge>
                            ) : (
                              <span className="text-sm text-gray-400">-</span>
                            )}
                          </div>
                          <div className="flex-1 min-w-[100px] text-center">
                            {row.totalConcluido ? (
                              <Badge variant="outline" className={d.badges.status.concluido}>
                                <span className={d.badges.dot.green} />
                                {row.totalConcluido}
                              </Badge>
                            ) : (
                              <span className="text-sm text-gray-400">-</span>
                            )}
                          </div>
                          <div className="flex-1 min-w-[130px] text-center">
                            <span className={d.table.cell}>{tma ? resultTimes(tma) : '-'}</span>
                          </div>
                          <div className="flex-1 min-w-[100px] text-center">
                            {row.totalAtrasados ? (
                              <Badge variant="outline" className={d.badges.status.atrasado}>
                                <span className={d.badges.dot.orange} />
                                {row.totalAtrasados}
                              </Badge>
                            ) : (
                              <span className="text-sm text-gray-400">-</span>
                            )}
                          </div>
                          <div className="flex-1 min-w-[90px] text-center">
                            {row.totalRecusados ? (
                              <Badge variant="outline" className={d.badges.status.recusado}>
                                <span className={d.badges.dot.red} />
                                {row.totalRecusados}
                              </Badge>
                            ) : (
                              <span className="text-sm text-gray-400">-</span>
                            )}
                          </div>
                          <div className="flex-1 min-w-[100px] text-center">
                            {row.totalCancelado ? (
                              <Badge variant="outline" className={d.badges.status.cancelado}>
                                <span className={d.badges.dot.gray} />
                                {row.totalCancelado}
                              </Badge>
                            ) : (
                              <span className="text-sm text-gray-400">-</span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </GenericTable>
                </div>
              </CardContent>
            </Card>
          ) : (
            <Card className={d.tableCard.container}>
              <CardContent className={d.tableCard.cardContent}>
                <div className={d.emptyState.container}>
                  <div className={d.emptyState.iconBox}>
                    <Iconify icon="eva:file-text-outline" className={d.emptyState.icon} />
                  </div>
                  <h3 className={d.emptyState.title}>Nenhum dado encontrado</h3>
                  <p className={d.emptyState.description}>Nao foram encontrados chamados para o periodo selecionado.</p>
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
}
